import React, { useState } from "react";
import Box from "@mui/material/Box";

import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Collapse,
} from "@mui/material";
import {
  ExitToApp,
  HelpOutlineOutlined,
  HomeOutlined,
  ExpandLess,
  ExpandMore,
  NoteOutlined,
  Person2Outlined,
  StarOutline,
} from "@mui/icons-material";

import { Link as RouterLink } from "react-router-dom";
import { ThemeDetails } from "../../theme/ThemeDetails";

type drawerComponentProps = {
  drawerWidth: number;
  mobileOpen: boolean;
  handleDrawerTransitionEnd: any;
  handleDrawerClose: any;
  activeItem: string;
  setActiveItem: (key: string) => void;
};

export const PlannerDrawer = ({
  drawerWidth,
  mobileOpen,
  handleDrawerTransitionEnd,
  handleDrawerClose,
  activeItem,
  setActiveItem,
}: drawerComponentProps) => {
  console.log(activeItem);
  const [openEvents, setOpenEvents] = useState(false);

  const handleClick = (key: string) => {
    if (key === "Eventos") {
      if (!openEvents) {
        setOpenEvents(true);
      }
    } else {
      setActiveItem(key);
    }
  };
  const drawer = (
    <Box
      sx={{
        backgroundColor:"#221835",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        height: "100%",
        mt: 2,
        color: "#FFF!important",
        ".MuiListItemIcon-root": {
          color: "inherit",
        },
      }}
    >
      <Box>
        <List>
          {[
            {
              text: "Inicio",
              icon: <HomeOutlined />,
              key: "Inicio",
              to: "/planner",
            },
            {
              text: "Eventos",
              icon: <StarOutline />,
              key: "Eventos",
              to: "#",
            },
            {
              text: "Clientes",
              icon: <NoteOutlined />,
              key: "Clientes",
              to: "/planner/clients",
            },
            {
              text: "Organización",
              icon: <Person2Outlined />,
              key: "Organización",
              to: "/planner/organization",
            },
            {
              text: "Centro de Ayuda",
              icon: <HelpOutlineOutlined />,
              key: "Help",
              to: "/planner/help",
            },
          ].map((item) => (
            <React.Fragment key={item.key}>
              <ListItem disablePadding>
                <ListItemButton
                  component={item.to !== "#" ? RouterLink : "div"}
                  to={item.to}
                  onClick={() => handleClick(item.key)}
                  style={{
                    margin: "0px 10px",
                    borderRadius: "5px",
                    color:
                      activeItem === item.key
                        ? ThemeDetails.palette.primary.main
                        : "inherit",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      marginRight: "-20px",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                  {item.key === "Eventos" &&
                    (openEvents ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
              </ListItem>
              {item.key === "Eventos" && (
                <Collapse in={openEvents} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      component={RouterLink}
                      to="/planner/events/create"
                      disablePadding
                      sx={{ pl: 4 }}
                    >
                      <ListItemButton
                        sx={{
                          color:
                            activeItem === "Crear Evento"
                              ? ThemeDetails.palette.primary.main
                              : "white",
                        }}
                        onClick={() => handleClick("Crear Evento")}
                      >
                        <ListItemText primary="Crear Evento" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      component={RouterLink}
                      to="/planner/events"
                      disablePadding
                      sx={{ pl: 4 }}
                    >
                      <ListItemButton
                        sx={{
                          color:
                            activeItem === "Todos los Eventos"
                              ? ThemeDetails.palette.primary.main
                              : "white",
                        }}
                        onClick={() => handleClick("Todos los Eventos")}
                      >
                        <ListItemText primary="Todos los Eventos" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
      </Box>

      <Divider sx={{ bgcolor: "#FFF", width: "90%", marginX: "auto" }} />

      <Box>
        <ListItem disablePadding>
          <ListItemButton
            component={RouterLink}
            to={"/"}
            style={{
              margin: "10px 10px",
              borderRadius: "5px",
            }}
          >
            <ListItemIcon
              sx={{
                marginRight: "-20px",
              }}
            >
              <ExitToApp />
            </ListItemIcon>
            <ListItemText primary={"Salir del panel"} />
          </ListItemButton>
        </ListItem>
      </Box>
    </Box>
  );
  return (
    
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label="Menu folders"
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        <Toolbar />
        {drawer}
      </Drawer>

      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
        open
      >
        <Toolbar />
        {drawer}
      </Drawer>
    </Box>
  );
};
